import { useEffect, useState } from "react";

// Detects whether the section currently sitting under the sticky nav is dark
// (marked with data-nav-theme="dark"), so the nav can invert its styling.
export function useNavTheme(offset = 72) {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    let raf = 0;

    const compute = () => {
      raf = 0;
      const zones = Array.from(document.querySelectorAll("[data-nav-theme]"));
      let current = "light";
      for (const el of zones) {
        const rect = el.getBoundingClientRect();
        if (rect.top <= offset && rect.bottom > offset) {
          current = el.getAttribute("data-nav-theme") || "light";
          break;
        }
      }
      setTheme((prev) => (prev === current ? prev : current));
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(compute);
    };

    compute();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [offset]);

  return theme;
}
